import React, { useEffect } from 'react';
import { Title } from 'components';
import { AuthContext } from 'contexts';
import errorReporter from '@app/errorReporter';
import { checkUserBillingPermission } from 'utils';
import { getStripeCustomerId } from 'api/BillingController';
import ManageCard from '../../../ManageCard';
import { CanManageBillingProfileType } from '../../../../pages/SubscriptionsPaymentsPage/SubscriptionsPageContext';

type PaymentMethodProps = {
  setCardStored: React.Dispatch<React.SetStateAction<boolean>>;
};
const PaymentMethod: React.FC<PaymentMethodProps> = ({ setCardStored }) => {
  const { auth } = React.useContext(AuthContext);

  const fetchCustomerId = async () => {
    try {
      const customerId = await getStripeCustomerId('orgBilling');
      if (customerId) setCardStored(true);
    } catch (error) {
      errorReporter.error(error);
      setCardStored(false);
    }
  };

  useEffect(() => {
    fetchCustomerId();
  }, []);

  const handleCardUpdateSuccess = async () => {
    await fetchCustomerId();
  };

  const canManageBilling = (): CanManageBillingProfileType => {
    if (!checkUserBillingPermission(auth) && !auth.isBrokerOfRecord) {
      return {
        response: false,
        message:
          'Only your Brokerage Owner or Broker of Record can update the payment method.',
      };
    }

    if (auth.assumingUserId || auth.isAssumedNotBB) {
      return {
        response: false,
        message: 'You cannot manage billing while assuming a user.',
      };
    }

    return {
      response: true,
    };
  };

  return (
    <>
      <Title level={4}>Payment Method</Title>
      <ManageCard
        productType="orgBilling"
        isBillingPage={false}
        canManageBilling={canManageBilling()}
        // We currently don't care about overdue balances when upgrading the user's plan
        isSubscriptionOverdue={{ response: false }}
        onCardUpdateSuccess={handleCardUpdateSuccess}
        stripePk={process.env.STRIPE_PK!}
      />
    </>
  );
};

export default PaymentMethod;
